export default __webpack_public_path__ + "static/media/trainer_tier.04df4abe.svg";